import { Tokens } from './types';

export const KEYCLOAK = '[KEYCLOAK]';
export const KEYCLOAK_STATE = `${KEYCLOAK} KEYCLOAK_STATE`;

export const keycloakMessage = (event?: string | unknown, tokens?: Tokens) => ({
  type: KEYCLOAK_STATE,
  payload: { event, tokens },
});
